import script from "./BaseNewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseNewsCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseNewsCard.vue?vue&type=style&index=0&id=12f9f0b5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f9f0b5"]])

export default __exports__